import React from "react"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconPrefix, IconName } from "@fortawesome/fontawesome-svg-core"
import { IconData } from "../../rows/DynamicRow"

export type iconSizeData = "xs" | "s" | "m" | "l" | "xl" | "xxl"

export const Icon = ({
  icon,
  name,
  size,
  className,
  source,
  svg,
  strokeWidth,
  color,
  style,
}: {
  name?: string
  icon?: IconData
  size?: iconSizeData
  className?: string
  source?: string
  svg?: boolean
  strokeWidth?: number
  color?: string
  style?: any
}) => {
  source = source || "feather.min"
  size = icon?.size || size || "m"

  if (icon != undefined) {
    switch (icon?.iconType) {
      case "fontawesome":
        name = icon.iconStyle + ":" + icon.icon
        break
      case "feather":
      default:
        name = icon.icon
        break
    }
  }

  if (name == "logo") {
    // The main logo is hard-coded for
    return (
      <svg
        className={`${className || ""}`}
        viewBox="0 0 118 32"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMinYMin meet"
        style={style}
      >
        <path d="M58.5855 12.4612C57.0469 12.4612 55.5083 13.2476 55.2716 14.8809H62.0178C61.8403 13.1871 60.1242 12.4612 58.5855 12.4612Z" />
        <path d="M31.0683 12.8242C28.9971 12.8242 27.281 14.2155 27.281 15.8488C27.281 17.482 28.9971 18.8733 31.0683 18.8733C33.1396 18.8733 34.7965 17.482 34.7965 15.8488C34.7373 14.2155 33.0804 12.8242 31.0683 12.8242Z" />
        <path d="M3.19559 12.4612C1.8345 12.4612 0.414243 13.1266 0 14.397V14.8204H6.62788C6.45035 13.1871 4.7342 12.4612 3.19559 12.4612Z" />
        <path d="M96.0452 12.8242C93.9739 12.8242 92.2578 14.2155 92.2578 15.8488C92.2578 17.482 93.9739 18.8733 96.0452 18.8733C98.1164 18.8733 99.7733 17.482 99.7733 15.8488C99.7142 14.2155 98.0572 12.8242 96.0452 12.8242Z" />
        <path d="M107.348 0H0V11.0095C0.946841 10.5255 2.01204 10.2836 3.13641 10.2836C6.21364 10.2836 9.46841 12.1588 9.11334 16.5747L0 16.5142V17.2401C0.414243 18.4499 1.77533 19.1758 3.37312 19.1758C5.32598 19.1758 6.15446 18.1474 6.50953 17.5425L9.11334 18.3894C8.52156 19.5388 7.1013 21.414 3.37312 21.414C2.01204 21.414 0.887663 21.172 0 20.7486V32H107.348L118 16.0302L107.348 0ZM17.2798 19.1153C19.2327 19.1153 20.2979 18.1474 20.7713 16.9376L23.0201 17.603C22.1916 20.0832 19.6469 21.293 17.2798 21.293C14.321 21.293 11.4213 19.4783 11.4213 15.7883C11.4213 12.0378 14.4985 10.2231 17.4574 10.2231C19.9428 10.2231 22.3099 11.4934 23.0792 14.034L20.8897 14.6994C20.4163 13.4291 19.4102 12.4612 17.3982 12.4612C15.4453 12.4612 13.7884 13.6711 13.7884 15.7883C13.7292 18.087 15.5045 19.1153 17.2798 19.1153ZM31.009 21.3535C27.8134 21.3535 25.2096 18.8733 25.2096 15.7883C25.2096 12.7032 27.8134 10.2231 31.009 10.2231C34.2638 10.2231 36.8084 12.7032 36.8084 15.7883C36.8084 18.8733 34.2638 21.3535 31.009 21.3535ZM47.4604 21.172H42.0161L38.347 10.6465H41.1876L44.7382 20.8091H44.7974L48.348 10.6465H51.1294L47.4604 21.172ZM58.8225 19.1758C60.7753 19.1758 61.6038 18.1474 61.9589 17.5425L64.5627 18.3894C63.9709 19.5388 62.5507 21.414 58.8225 21.414C54.6209 21.414 52.6088 19.0548 52.6088 15.9093C52.6088 12.0983 55.6269 10.2836 58.5266 10.2836C61.6038 10.2836 64.8586 12.1588 64.5035 16.5747H55.2718C55.2718 18.1474 56.8696 19.1758 58.8225 19.1758ZM75.2146 13.0057C72.1374 12.2798 69.7111 14.276 69.7111 16.0907L69.652 21.172H67.0481V10.6465H69.7703L69.7111 14.8809H69.7703C70.3029 12.5822 71.9007 10.1626 75.2146 10.344V13.0057ZM82.3751 21.3535C78.4694 21.3535 76.9308 19.5992 76.3982 18.4499L78.7653 17.5425C79.1204 18.2684 80.008 19.1758 82.3751 19.2363C83.8546 19.2968 85.8074 18.9943 85.8074 17.7845C85.8074 17.0586 85.1565 16.8771 84.1505 16.8771H82.0792C79.7121 16.8771 76.8716 16.2722 76.8716 13.7921C76.8716 11.5539 79.7121 10.4045 82.6118 10.465C84.8014 10.5255 86.9318 11.3119 87.8786 13.0662L85.5707 14.034C85.1565 13.1871 84.0913 12.6427 82.3751 12.6427C80.7773 12.6427 79.2979 12.9452 79.2979 13.7316C79.2979 14.8809 81.7834 14.6994 83.4403 14.7599C85.6891 14.8204 88.3521 15.1834 88.2929 17.7845C88.1745 20.8091 84.6831 21.3535 82.3751 21.3535ZM95.986 21.3535C92.7904 21.3535 90.1866 18.8733 90.1866 15.7883C90.1866 12.7032 92.7904 10.2231 95.986 10.2231C99.2407 10.2231 101.785 12.7032 101.785 15.7883C101.785 18.8733 99.2407 21.3535 95.986 21.3535Z" />
      </svg>
    )
  }

  if (name.match(/f(ab|as|al|ar|ad):.*/)) {
    return (
      <FontAwesomeIcon
        icon={[name.substr(0, 3) as IconPrefix, name.substr(4) as IconName]}
        className={`icon icon--${size} ${className || ""}`}
        style={{ ...style, strokeWidth, color }}
      />
    )
  }

  if (svg) {
    return (
      <svg className={`${className || ""}`} style={{ ...style, strokeWidth, color }}>
        {name ? <use xlinkHref={`/img/${source}.svg#${name}`}></use> : <use href={`/img/${source}.svg`}></use>}
      </svg>
    )
  } else {
    return (
      <svg className={`icon icon--${size} ${className || ""}`} style={{ ...style, strokeWidth, color }}>
        {name ? (
          <use xlinkHref={`/img/icons/${source}.svg#icon-${name}`}></use>
        ) : (
          <use href={`/img/icons/${source}.svg`}></use>
        )}
      </svg>
    )
  }
}

export default Icon
